module.exports = "/images/us.svg?6c4096b9f9db7b0acefa55fce97617b2";